var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2103 10.5853L33.6057 1.49872C32.5841 0.532213 31.247 0 29.8407 0H11.5547C8.53383 0 6.07617 2.45766 6.07617 5.47852V45.5215C6.07617 48.5423 8.53383 51 11.5547 51H39.4453C42.4662 51 44.9238 48.5423 44.9238 45.5215V14.5651C44.9238 13.0661 44.2993 11.6154 43.2103 10.5853ZM40.308 11.9531H32.8711C32.5965 11.9531 32.373 11.7297 32.373 11.4551V4.44616L40.308 11.9531ZM39.4453 48.0117H11.5547C10.1816 48.0117 9.06445 46.8946 9.06445 45.5215V5.47852C9.06445 4.1054 10.1816 2.98828 11.5547 2.98828H29.3848V11.4551C29.3848 13.3774 30.9487 14.9414 32.8711 14.9414H41.9355V45.5215C41.9355 46.8946 40.8184 48.0117 39.4453 48.0117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1582 19.9219H14.2441C13.419 19.9219 12.75 20.5909 12.75 21.416C12.75 22.2412 13.419 22.9102 14.2441 22.9102H36.1582C36.9834 22.9102 37.6523 22.2412 37.6523 21.416C37.6523 20.5909 36.9834 19.9219 36.1582 19.9219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1582 27.8906H14.2441C13.419 27.8906 12.75 28.5596 12.75 29.3848C12.75 30.2099 13.419 30.8789 14.2441 30.8789H36.1582C36.9834 30.8789 37.6523 30.2099 37.6523 29.3848C37.6523 28.5596 36.9834 27.8906 36.1582 27.8906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4877 35.8594H14.2441C13.419 35.8594 12.75 36.5284 12.75 37.3535C12.75 38.1787 13.419 38.8477 14.2441 38.8477H21.4877C22.3129 38.8477 22.9819 38.1787 22.9819 37.3535C22.9819 36.5284 22.3129 35.8594 21.4877 35.8594Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.55d00ade.svg";
export { ForwardRef as ReactComponent };